module.exports = __webpack_public_path__ + "static/media/crown-premium.1fe58ae9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/crown-premium.svg
// module id = 465
// module chunks = 0